// extracted by mini-css-extract-plugin
export var captions = "Figure-module--captions--0fbd6";
export var container = "Figure-module--container--176dd";
export var credit = "Figure-module--credit--a51d2";
export var discourageSaving = "Figure-module--discourage-saving--2f848";
export var full = "Figure-module--full--d6450";
export var image = "Figure-module--image--523dc";
export var imageContainer = "Figure-module--image-container--c08a4";
export var inner = "Figure-module--inner--da0b8";
export var large = "Figure-module--large--0ff89";
export var leftMargin = "Figure-module--left-margin--9aeb8";
export var medium = "Figure-module--medium--93e12";
export var rightMargin = "Figure-module--right-margin--3aaf0";
export var small = "Figure-module--small--22ffe";
export var tiny = "Figure-module--tiny--f9c54";